import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import TutoringLocations from './TutoringLocations';

const getColumns = (actionFunction) => {
  return [
    {
      field: 'SUBJECT',
      valueGetter: (params, row) => row.SUBJECT,
      headerName: 'Subject',
      width: 80,
    },
    {
      field: 'COURSE_NUMBER',
      valueGetter: (params, row) => row.COURSE_NUMBER,
      headerName: '#',
      width: 40,
    },
    {
      field: 'COURSE_TITLE',
      valueGetter: (params, row) => row.COURSE_TITLE,
      headerName: 'Title',
      flex: 3,
    },
    {
      field: 'locations',
      headerName: 'Tutoring Info/Location',
      minWidth: 150,
      flex: 2,
      renderCell: (params) => <TutoringLocations row={params.row} />,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 80,
      cellClassName: 'actions',
      type: 'actions',
      getActions: (event) => [
        <GridActionsCellItem
          id={`tutoring__gridActionsCellItem_delete_` + event.row.SUBJECT + event.row.COURSE_NUMBER}
          icon={
            <FontAwesomeIcon
              id={`tutoring__icon_delete_` + event.row.SUBJECT + event.row.COURSE_NUMBER}
              icon={faTrash}
            />
          }
          label="Delete"
          onClick={() => actionFunction(event.row)}
        />,
      ],
    },
    { field: 'createdAt', valueGetter: (params, row) => row.createdAt },
  ];
};

export default getColumns;
